import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class BullkService {
    private readonly getBullkURL = `/admin/bulk/all_bulk_forms`;
    private readonly acceptOrRejectBullkURL = `/admin/bulk/bulk_forms/`;
    // ---------------------------------------------------------------

    getBullk(params: { pageSize: number; pageNumber: number }) {
        return fetchWithRetry(API.get(this.getBullkURL, { params }));
    }

    acceptOrRejectBullk(id: number, body: { proposedUnitPrice: string; sellerNote: string; status: string ; frequency : string}) {
        return fetchWithRetry(API.patch(`${this.acceptOrRejectBullkURL}${id}`, body));
    }
}

export default new BullkService();
